import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { VideosComponent } from './videos.component';

/* Routes */
import { VideosRoutingModule } from './videos-routing.module';

/* Services */
import { VideosService } from './videos.service';

// Atuar na conversão do header para que as Apis do TI, consigam
// receber as aquisições corretamente com Json via "RESPONSE HEADERS" e "REQUEST HEADERS"
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [VideosComponent],
    imports: [CommonModule, RouterModule, VideosRoutingModule, NgbModule, Interceptor, ThemeModule],
})
export class VideosModule {}
